import { type CSSProperties, memo, useCallback } from 'react';

import { X } from 'lucide-react';
import type { ClearIndicatorProps } from 'react-select';

import { Icon } from '../../icon';

// !important to check with khubaib
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ClearIndicator = memo((props: ClearIndicatorProps<any, true>) => {
  const {
    children = <Icon icon={X} className="text-c-card-muted! size-3.5" />,
    getStyles,
    innerProps: { ref, onMouseDown, onTouchEnd, ...restInnerProps },
    clearValue,
  } = props;

  const handleMouseDown = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      clearValue();
      if (this === e.target && onMouseDown) {
        onMouseDown(e);
      }
      e.stopPropagation();
    },
    [clearValue, onMouseDown]
  );

  const handleTouchEnd = useCallback(
    (e: React.TouchEvent<HTMLDivElement>) => {
      clearValue();
      if (this === e.target && onTouchEnd) {
        onTouchEnd(e);
      }

      e.stopPropagation();
    },
    [clearValue, onTouchEnd]
  );

  return (
    <div
      {...restInnerProps}
      onMouseDown={handleMouseDown}
      onTouchEnd={handleTouchEnd}
      ref={ref}
      style={getStyles('clearIndicator', props) as CSSProperties}
      className="w-5 cursor-pointer p-0! px-1!"
    >
      {children}
    </div>
  );
});
